import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stepper-step-content" }

import { getCurrentInstance, inject, onBeforeUnmount, computed } from 'vue';
// @ts-expect-error raison: lib externe mal typée

import type { CustomStepperContext } from './CustomStepper.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomStepperStep',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

const stepper = inject<CustomStepperContext>('customStepper');
if (!stepper) {
    throw new Error('<custom-stepper-step> doit être utilisé à l\'intérieur de <custom-stepper>');
}

const uid = getCurrentInstance()!.uid;

stepper.registerStep({ uid, title: props.title });
onBeforeUnmount(() => stepper.unregisterStep(uid));

const index = computed(() => stepper.steps.value.findIndex((step) => step.uid === uid));
const isActive = computed(() => stepper.activeIndex.value === index.value);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ], 512)), [
    [_vShow, isActive.value]
  ])
}
}

})